import React from "react";

// @mui material components
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React context
import { useMaterialUIController } from "context";

function ScheduleCard({ no, id, title, startTime, endTime, description, handleDelete, handleEdit }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <MDBox
      component="li"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      bgColor={darkMode ? "transparent" : "grey-100"}
      borderRadius="lg"
      p={4}
      m={0}
    >
      <Grid container>
        <Grid item xs={12} md={8} lg={9}>
          <MDBox mt={3}>
            <MDBox width="100%" display="flex" flexDirection="column">
              <MDBox mb={1} lineHeight={0} display="flex" flexDirection="row">
                <MDTypography variant="subtitle1" fontWeight="medium">
                  {no}
                </MDTypography>
              </MDBox>
              <MDBox mb={1} lineHeight={0} display="flex" flexDirection="row">
                <MDTypography variant="subtitle1" color="text">
                  Title:&nbsp;&nbsp;&nbsp;
                  <MDTypography variant="subtitle1" fontWeight="medium">
                    {title}
                  </MDTypography>
                </MDTypography>
              </MDBox>
              <MDBox mb={1} lineHeight={0} display="flex">
                <MDTypography variant="subtitle1" color="text">
                  Start:&nbsp;&nbsp;&nbsp;
                  <MDTypography variant="subtitle1" fontWeight="medium">
                    {startTime ? new Date(startTime).toLocaleString() : "—"}
                  </MDTypography>
                </MDTypography>
              </MDBox>
              <MDBox mb={1} lineHeight={0} display="flex">
                <MDTypography variant="subtitle1" color="text">
                  End:&nbsp;&nbsp;&nbsp;
                  <MDTypography variant="subtitle1" fontWeight="medium">
                    {endTime ? new Date(endTime).toLocaleString() : "—"}
                  </MDTypography>
                </MDTypography>
              </MDBox>
              {description && (
                <MDBox mb={1} lineHeight={0} display="flex">
                  <MDTypography variant="subtitle1" color="text">
                    Description:&nbsp;&nbsp;&nbsp;
                    <MDTypography variant="subtitle1" fontWeight="medium">
                      {description}
                    </MDTypography>
                  </MDTypography>
                </MDBox>
              )}
            </MDBox>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <MDBox display="flex" justifyContent="end">
            <MDBox mr={1}>
              <MDButton variant="text" color="error" onClick={() => handleDelete(id)}>
                <Icon>delete</Icon>&nbsp;delete
              </MDButton>
            </MDBox>
            <MDButton
              variant="text"
              color={darkMode ? "white" : "dark"}
              onClick={() => handleEdit({ id, title, startTime, endTime, description })}
            >
              <Icon>edit</Icon>&nbsp;edit
            </MDButton>
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default ScheduleCard;
